import { createReducer } from '@reduxjs/toolkit';
import {
  GET_MOBILE_PUSH_OPERATIONS,
  INIT_MOBILE_PUSH_OPERATION,
  SELECT_PRIVATE_MONEY_FOR_MOBILE_PUSH_OPERATION,
} from '../actions/mobile-push-operations';
import { components } from '../schema/docs/api/admin';

// TODO: infer operation type from docs
type PrivateMoney = components['schemas']['PrivateMoney'];
export type MobilePushOperationState = {
  private_money: null | PrivateMoney;
  rows: unknown[];
  pagination: unknown;
};

const initialState: MobilePushOperationState = {
  private_money: null,
  rows: [],
  pagination: {},
};

const mobilePushOperationReducer = createReducer(initialState, (builder) =>
  builder
    .addCase(INIT_MOBILE_PUSH_OPERATION, (state) => ({ ...state, ...initialState }))
    .addCase(GET_MOBILE_PUSH_OPERATIONS, (state, action) => {
      return { ...state, ...action.payload };
    })
    .addCase(SELECT_PRIVATE_MONEY_FOR_MOBILE_PUSH_OPERATION, (state, action) => {
      return { ...state, private_money: action.payload };
    })
);

export default mobilePushOperationReducer;
